// extracted by mini-css-extract-plugin
module.exports = {"image":"src-hellospa-components-signature-request-display-field-signature__image--RGAN3"};